import Installer from './Installation';

export default {
  linkName: 'Installation',
  component: Installer,
  path: '/hardware/installer/installation/*',
  rootPath: { name: 'Hardware', uri: '/hardware' },
  subPath: [
    { name: 'Installer', uri: '/hardware/installer' },
    { name: 'Installation' },
  ],
};
